// Checkin.js
// This is the client details view.

import React, { useCallback, useEffect, useReducer, useRef } from "react";
import { ActivityIndicator, Image, View, Text } from "react-native";
import { faCircleUser } from "@fortawesome/free-regular-svg-icons";
import { faPaw, faUser, faUsers, faTriangleExclamation, faStar, faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";

import Anchor from "components/Partials/Anchor";
import { stateReducer } from "components/helpers/stateReducer";
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
import { openSideScreen } from "components/Views/SideScreens/SideScreenLoader";

import { UpcomingAppointments } from "components/Views/SideScreens/Partials";


const Checkin = ({assessment_id}) => {
  const _theme = window.main.theme;

  if (!Number(assessment_id)) {
    return (
      <View id="patient_details_invalid" style={{..._theme.tiles.outerContainer,alignItems:"center",paddingTop:50}}>
        <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.caution,fontSize:18,lineHeight:22}}>Invalid assessment.</Text>
      </View>
    );
  }

  const [assessmentViewState, assessmentViewSetState] = useReducer(stateReducer, {
    assessment: {},
    assessmentLoading: true,  // ⬅ Default TRUE for iniital 'loading' state.
  });
  const _assessmentId = useRef(0);

  const initialDataLoad = useCallback(async () => {
    if (!!Number(_assessmentId.current)) {
      return false;
    }
    _assessmentId.current = assessment_id;
    const _stateProps = [
      { key: "assessmentLoading", type: "boolean", assessmentLoading: false }
    ];
    try {
      const [_assessment] = await Promise.all([
        window.main.axios.get(window.main.api.getAssessment.replace("{assessment_id}",assessment_id)),
      ]);
      if (!_assessment || !_assessment.data || !Number(_assessment.data.id)) {
        throw _assessment;
      }
      _stateProps.push({ key: "assessment", type: "object", assessment: _assessment.data });
      // Update all states at once:
      assessmentViewSetState(_stateProps);
    } catch (err) {
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      assessmentViewSetState(_stateProps);
    }
  }, []);

  useEffect(() => {
    initialDataLoad();
  }, []);  // ⬅ Trigger only once on initial page load.

  if (!assessmentViewState.assessmentLoading && !Number(assessmentViewState.assessment.id)) {
    return (
      <View id="client_details_error" style={{..._theme.tiles.outerContainer,alignItems:"center",paddingTop:50}}>
        <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.caution,fontSize:18,lineHeight:22}}>Assessment failed to load.</Text>
      </View>
    );
  }

  return (
    <>

      {!!Number(assessmentViewState.assessment.id) &&
        <View id="client_details__sidescreen" style={_theme.tiles.outerContainer}>

        </View>
      }

      {!window.main.lib.getLoadingState() && !!assessmentViewState.assessmentLoading &&
        // <View style={{zIndex:99999, backgroundColor:"rgba(255,255,255,0.7)", top:0, left:0, bottom:0, right:0, position:(window.main.platform_os==="web"?"fixed":"absolute")}}>
        <View style={{zIndex:99999,backgroundColor:"rgba(255,255,255,0.7)",top:0,left:0,bottom:0,right:0,position:"absolute"}}>
          <ActivityIndicator size="large" color={_theme.colors.mode.base} style={{marginTop:20}} />
        </View>
      }

    </>
  );

};

// Exports

const config = {
  key: "checkin",
  title: "Appointment Check-In",
  view: Checkin,
  menu: "sidescreen",
  iconSource: "fa",
  icon: faUser,
};

export default Checkin;
export {
  config,
};
